// frontend/src/services/api.js
import axios from "axios";

const API_URL = "https://api.seengineering-tn.com/api";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (credentials) => api.post("/auth/login", credentials);
export const register = (userData) => api.post("/auth/register", userData);
export const getMe = () => api.get("/auth/me");

// Categories
export const getCategories = () => api.get("/categories");
export const getCategory = (id) => api.get(`/categories/${id}`);
export const createCategory = (data) => api.post("/categories", data);
export const updateCategory = (id, data) => api.put(`/categories/${id}`, data);
export const deleteCategory = (id) => api.delete(`/categories/${id}`);

// Services
export const getServices = (params) => api.get("/services", { params });
export const getService = (id) => api.get(`/services/${id}`);
export const createService = (formData) => {
  return api.post("/services", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
export const updateService = (id, formData) => {
  return api.put(`/services/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
export const deleteService = (id) => api.delete(`/services/${id}`);

// Realizations
export const getRealizations = (params) => api.get("/realizations", { params });
export const getRealization = (id) => api.get(`/realizations/${id}`);
export const createRealization = (formData) => {
  return api.post("/realizations", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
export const updateRealization = (id, formData) => {
  return api.put(`/realizations/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
export const deleteRealization = (id) => api.delete(`/realizations/${id}`);

// Contact
export const submitContact = (formData) => {
  return api.post("/contact", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
export const getContacts = (params) => api.get("/contact", { params });
export const updateContactStatus = (id, status) => {
  return api.put(`/contact/${id}/status`, { status });
};

// Search
export const search = (params) => api.get("/search", { params });

// Internships
export const getInternships = (params) => api.get("/internships", { params });
export const getInternship = (id) => api.get(`/internships/${id}`);
export const createInternship = (data) => api.post("/internships", data);
export const updateInternship = (id, data) =>
  api.put(`/internships/${id}`, data);
export const deleteInternship = (id) => api.delete(`/internships/${id}`);

// Internship Applications
export const submitInternshipApplication = (formData) => {
  return api.post("/applications", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
export const getInternshipApplications = (params) =>
  api.get("/applications/", { params });
export const getInternshipApplication = (id) =>
  api.get(`/applications/${id}`);
export const updateApplicationDecision = (id, data) => {
  return api.patch(`/applications/${id}/decision`, data);
};

export const updateApplication = (id, data) => api.put(`/applications/${id}`, data);

export const deleteInternshipApplication = (id) =>
  api.delete(`/applications/${id}`);

export const isFormActive = (params) => api.get("/config/active", { params });

export const getConfig = (params) =>
  api.get("/config", { params });

export const updateConfig = (configData) => {
  return api.put(`/config`, configData);
};

export const downloadCV = (cvPath) => {
  const baseUrl = API_URL.replace("/api", "");
  return `${baseUrl}/${cvPath}`;
};

export const getFileUrl = (filePath) => {
  const baseUrl = API_URL.replace("/api", "");
  return `${baseUrl}/${filePath}`;
};

export default api;